var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"right-menu-item",attrs:{"to":"/msgList"}},[_c('el-badge',{staticStyle:{"line-height":"initial"},attrs:{"value":_vm.total}},[_c('i',{staticClass:"el-icon-message-solid"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }